export const mergeAndSortMessages = (messages, autoMessages) => {
  const msgs = Array.isArray(messages) ? messages : [];
  const autoMsgs = Array.isArray(autoMessages) ? autoMessages : [];

  const allMessages = [...msgs, ...autoMsgs];

  allMessages.sort((a, b) => {
    const dateA = new Date(a.attributes.createdAt).getTime();
    const dateB = new Date(b.attributes.createdAt).getTime();
    return dateA - dateB;
  });

  return allMessages;
};
